app.controller("SubjectMigrationControllerNew", [
    "$scope", "StaticData", "ProgramService", "MigrationNew", "Subject", "InfoModal", "toastr", "$stateParams", "$state",
    function ($scope, StaticData, ProgramService, MigrationNew, Subject, InfoModal, toastr, $stateParams, $state) {
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
            $scope.emisSubject = $stateParams.subject;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            MigrationNew.list({
                page: page,
                limit: $scope.itemsPerPage,
                subject: $stateParams.subject
            }).then(function (data) {
                $scope.migrations = data.docs;
                $scope.totalItems = data.total;
                cb();
            })
        }

        $scope.getSubjects = function (query, migration) {
            // var program = $scope.chosenPrograms[migration];
            return Subject.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.getEmisSubjects = function () {
            $state.go(".", {subject: $scope.emisSubject});
        };

        $scope.save = function (migration) {
            var subject = migration.newSubject;
            if (!subject || !subject._id) {
                return toastr.error('', 'საგანი არაა არჩეული სრულად.');
            }

            MigrationNew.save({
                newSubject: subject._id,
                migration: migration._id
            }).then(function (data) {
                loadPage($stateParams.page);
                toastr.success('', 'საგნის შესაბამისობა წარმატებით განხორციელდა.');
            })
        };

        $scope.refresh = function () {
            $state.go(".", {subject: null, program: null, emisProgram: null});
        };
    }
]);